<template>
  <div class="etermin-step calender">
    <div class="date-wrapper row rows row-s">
      <div class="col-12 col-lg pe-lg-2 pb-lg-4 pb-2">
        <div class="date-text border-radius-main bg-secondary-l h-100 p-md-8 p-4 border-radius-main">
          <h3 class="mb-1 pb-4 calendar-titles h3 font-weight-600 text-left">
            {{ text.date }}
          </h3>
          <datepicker class="flex-1" :full-month-name="true" :language="de" :inline="true" :monday-first="true" :disabled-dates="calender.disabledDates" :highlighted="calender.highlighted" :value="calender.date" @selected="getSelected" @changedMonth="getChangedMonth"></datepicker>
        </div>
      </div>
      <div class="col-12 col-lg ps-lg-2 pb-lg-4 pb-2">
        <div class="time-select bg-secondary-l border-radius-main h-100 p-md-8 p-4 h-100">
          <h3 class="text-left mb-1 pb-4 border-l-bottom-white uhrzeit-title h3">
            {{ text.time }}
          </h3>
          <div class="text-left mb-2">
            <h4 class="m-0 text-s font-weight-600" v-show="calender.times && calender.times.length>0">
              {{ text.open_hours }}: {{ openingHours }}
            </h4>
          </div>
          <div class="times d-flex flex-wrap align-items-start">
            <div v-for="(item, index) in calender.times" :key="item.id" :data-index="index" class="app-date text-center" :class="{ active: item.date==appointement.date &&  item.time==appointement.time}" @click="addDate(item)">
              <div class="v-flex justify-content-center py-2 font-weight-600 ">
                {{ item.time }}
              </div>
            </div>
          </div>
          <h4 class="mb-1 text-s font-weight-600" v-if="appointement.time!=null">{{ appointement.date | date}} . {{ appointement.time }} - {{ getAppointementEnd(appointement.services[0],appointement.date, appointement.time) }} Uhr </h4>
          <h4 class="text-s font-weight-600">Filiale: {{ selectedStore.title }}</h4>
          <div v-show="calender.times && calender.times.length==0 && loading.status === false" class="vue-error-termin">Keine Termine am
            {{calender.date |date }} verfügbar
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import {de} from 'vuejs-datepicker/dist/locale'
import { mapState, mapGetters } from 'vuex'
import ServiceDrupal from '@/services/ServiceDrupal.js'

moment.locale('de')
const now = new Date(moment())

export default {
    name: 'termin-step',
    props: {
        appointement: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            de: de,
            id: 1,
            openingHours : null,
            text: {
                date: 'Datum',
                time: Drupal.t('Time'),
                open_hours: Drupal.t('Opening hours')
            }
        }
    },
    components: {
        Datepicker
    },
    filters: {
        time: function (value) {
            if (value) {
                var time = value.toString().split('T').pop()
                return time.substring(0, time.length - 3)
            }
        },
        date: function (value) {
            return moment(value).format('dddd, DD. MMMM YYYY')
        }
    },
    computed: {
        ...mapState({
            steps: state => state.etermin.steps,
            calender: state => state.etermin.calender,
        }),
        ...mapGetters('etermin', ['getActiveStep']),
        ...mapGetters('etermin', ['getAppointementEnd']),
        ...mapState([
            'loading',
            'selectedStore'
        ])
    },
    methods: {
        formatDate : function(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-')
        },
        getSelected: function (date) {
            this.$store.dispatch('etermin/selectDate', date)
            this.$emit('getTimeSlots', this.formatDate(moment(date)), 0)
            let dayNumber = moment(date).isoWeekday();
            this.checkifExistWorkingDay(dayNumber)
        },
        checkifExistWorkingDay: function (dayNumber) {
            var found = false;
            for (var i = 0; i < this.selectedStore.openinghours.length && !found; i++) {
                var value = this.selectedStore.openinghours[i]
                if (value['day'] == dayNumber) {
                    found = true
                    this.openingHours =`${this.stringToDateTime(value['starthours'])} - ${this.stringToDateTime(value['endhours'])}`
                }
            }
            if(!found)
              this.openingHours = Drupal.t('Closed')
        },
        stringToDateTime : function (date_string) {
            let Stringdate = date_string.toString();
            let dateString = Stringdate.length === 3 ? '0' + Stringdate : Stringdate
            let hours = dateString.substring(0, 2)
            let minutes = dateString.substring(2)
            return hours + ':' + minutes
        },
        addDate: function (item) {
            this.appointement.time = null
            this.appointement.date = item.date
            this.appointement.time = item.time
            this.$store.dispatch('etermin/validateStep', {index: this.id, status: 1})
        },
        getChangedMonth: function (date) {
            this.$emit('getTimeSlots', this.formatDate(moment(date)), 1)
        }
    },
    mounted () {
       let dayNumber = moment(this.calender.date).isoWeekday()
       this.checkifExistWorkingDay(dayNumber)
       this.$emit(`mounted`)
    }
}
</script>

<style lang="css">

</style>
